import { VBHover } from './hover';
import { pluginFactory } from '../../utils/plugins';
var VBHoverPlugin = /*#__PURE__*/pluginFactory({
  directives: {
    VBHover: VBHover
  }
});
export { VBHoverPlugin, VBHover };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/directives/hover/index.js
// module id = 379
// module chunks = 0